module.exports = __webpack_public_path__ + "img/feature_buy_zh.45b0a13d.png";